import React, { Component, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { MuiThemeProvider, CssBaseline } from '@material-ui/core';
import LanguageProvider from './providers/LanguageProvider';
import Layout from './components/Layout';
import ComponentOrSpinner from './components/ComponentOrSpinner';
import theme from './theme';
import './fonts/fonts.css';

const CustomerRequisition = React.lazy(() => import('./components/customerRequisition/CustomerRequisition'));
const VendorRequisition = React.lazy(() => import('./components/vendorRequisition/VendorRequisition'));
const NotFound = React.lazy(() => import('./components/NotFound'));
const ThankYou = React.lazy(() => import('./components/ThankYou'));
const Maintenance = React.lazy(() => import('./components/Maintenance'));
const Error = React.lazy(() => import('./components/Error'));
const CarReturn = React.lazy(() => import('./components/dialogManagerForms/carForms/CarReturn'));
const CarPickup = React.lazy(() => import('./components/dialogManagerForms/carForms/CarPickup'));
const RepaymentPrivate = React.lazy(() => import('./components/dialogManagerForms/repayment/RepaymentPrivate'));
const RepaymentVendor = React.lazy(() => import('./components/dialogManagerForms/repayment/RepaymentVendor'));

const withIntel = (Component, defaultLang) => (props) => (
  <LanguageProvider match={props.match} defaultLang={defaultLang}>
    <Component {...props} />
  </LanguageProvider>
);

export default class App extends Component {
  displayName = App.name

  render() {
    return (
      <Layout>
        <MuiThemeProvider theme={theme}>
          <CssBaseline />
          <Suspense fallback={<ComponentOrSpinner isLoading/>}>
            <Switch>
              <Route path='/maintenance/' component={withIntel(Maintenance, "da")} />
              <Route path='/:lang?/customerRequisition/:id' component={withIntel(CustomerRequisition)} />
              <Route path='/:lang?/car-return/' component={withIntel(CarReturn)} />
              <Route path='/:lang?/car-pickup/' component={withIntel(CarPickup)} />
              <Route path='/repayment-private/' component={withIntel(RepaymentPrivate, "da")} />
              <Route path='/repayment-vendor/' component={withIntel(RepaymentVendor, "da")} />
              <Route path='/vendorRequisition/:id' component={withIntel(VendorRequisition, "da")} />
              <Route path='/:lang?/thankYou/' component={withIntel(ThankYou)} />
              <Route path='/:lang?/Error/' component={withIntel(Error)} />
              <Route path='/:lang?/*' component={withIntel(NotFound)} />
              <Route path='*' component={withIntel(NotFound)} />
            </Switch>   
          </Suspense>
        </MuiThemeProvider>
      </Layout>
    );
  }
}
